type ComputeRange<
  N extends number,
  Result extends Array<unknown> = [],
> = Result['length'] extends N
  ? Result
  : ComputeRange<N, [...Result, Result['length']]>;

export type ClientErrorStatus = Exclude<
  ComputeRange<500>[number],
  ComputeRange<400>[number]
>;
export type ServerErrorStatus = Exclude<
  ComputeRange<600>[number],
  ComputeRange<500>[number]
>;

export function deepMerge<T extends object, U extends object>(target: T, source: U): T & U {
  if (source instanceof FormData) {
    return source as any;
  }

  const output = { ...target } as any;

  if (source && typeof source === 'object' && !Array.isArray(source)) {
    Object.keys(source).forEach((key) => {
      const sourceValue = (source as any)[key];
      const targetValue = (target as any)[key];

      if (sourceValue && typeof sourceValue === 'object' && !Array.isArray(sourceValue)) {
        output[key] = deepMerge(
          targetValue && typeof targetValue === 'object' ? targetValue : {},
          sourceValue
        );
      } else {
        output[key] = sourceValue;
      }
    });
  }

  return output as T & U;
}
